/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Affiliate from '../Affiliate'
import RequestPayment from '../RequestPayment'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/affiliates',
    name: 'affiliate',
    component: Affiliate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/request-payments/:id',
    name: 'request-payments',
    component: RequestPayment,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/affiliate/routes/index.js